
export const gjtom3 = (gj: number) => {
  return Math.floor(gj * 32.67);
};

export const m3togj = (m3: number) => {
  return Math.floor(m3 / 32.67);
};
